import { useRef } from "react";
import PropTypes from "prop-types";

import Banner from "./Banner";
import JobInformation from "./JobInformation";
import FormSection from "./FormSection";

const jobData = {
  title: "JAVA Developer",
  summary: `
    We are on the lookout for a self-driven and enthusiastic Java
    Developer (Fresher) to be part of our backend engineering
    team. The ideal candidate should have a solid understanding of
    Java programming fundamentals, object-oriented design, and a
    willingness to learn and work with modern Java frameworks and
    tools.
  `,
  responsibilities: [
    "Assist in the design, development, and maintenance of Java-based applications.",
    "Work with Spring Boot or other Java frameworks to build robust APIs.",
    "Collaborate with front-end developers, QA engineers, and designers.",
    "Write clean, efficient, and well-documented code.",
    "Participate in code reviews and continuous integration/deployment (CI/CD) processes.",
  ],
  qualifications: [
    "Bachelor’s degree in Computer Science, IT, Engineering, or related field.",
    "(Eligible: B.Sc (CS/IT), B.E/B.Tech, BCA, MCA)",
    "Strong understanding of core Java and object-oriented programming.",
    "Internship or academic project experience in Java development is a plus.",
  ],
  skills: [
    "Proficiency in Java SE and familiarity with Java EE or Spring Boot.",
    "Basic knowledge of SQL and relational databases (e.g., MySQL, PostgreSQL).",
    "Understanding of RESTful APIs and backend architecture.",
    "Familiarity with tools like Maven, Git, and IDEs like IntelliJ or Eclipse.",
    "Strong analytical and logical thinking.",
    "Good communication and teamwork skills.",
  ],
};

const SectionList = ({ title, items }) => (
  <div>
    <h3 className="text-[20px] font-semibold text-green-600 mb-1">
      {title}
    </h3>
    <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

    <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  </div>
);

SectionList.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const JobDetails = () => {
  const applyFormRef = useRef(null);

  return (
    <>
      <div className="bg-white text-gray-800">
        <Banner
          config={{
            applyFormRef,
            title: jobData.title,
          }}
        />

        <div className="bg-white px-6 md:px-16 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">
            <div className="lg:col-span-2 space-y-12">
              <div>
                <h2 className="text-[32px] font-semibold text-[#212129] mb-6">
                  Job Summary
                </h2>

                <p className="text-[#212129] text-[18px] leading-8 mb-6">
                  {jobData.summary}
                </p>

                <SectionList
                  title="Key Responsibilities"
                  items={jobData.responsibilities}
                />
              </div>

              <SectionList
                title="Qualifications"
                items={jobData.qualifications}
              />

              <SectionList
                title="Skills & Competencies"
                items={jobData.skills}
              />
            </div>

            <JobInformation />
          </div>
        </div>
      </div>

      <FormSection applyFormRef={applyFormRef} />
    </>
  );
};

export default JobDetails;
